import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { LinkButton } from '../../atoms/LinkButton';
import { TemplatesList } from '../../organisms/TemplatesList';

export const TemplatesPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <Box display='flex' pb={2}>
        <Typography variant="h4" flexGrow={1}>Templates</Typography>
        <LinkButton to="new">Create New</LinkButton>
      </Box>
      <TemplatesList onRowClick={(id: string) => navigate({pathname: `${id}`})}/>
    </>
  );
};
